export type { FoodOption, ChoiceGroup, Meal, Regimen } from "@/data/meal-plan/types.ts";

export { rominaRestRegimen } from "./rest.ts";

import { rominaRestRegimen } from "./rest.ts";
import type { Regimen } from "@/data/meal-plan/types.ts";

export const rominaRegimens: Regimen[] = [rominaRestRegimen];
